import { IGenericSelectOption } from '../../shared/types/forms';
import { TInputUnitPosition, TInputFormatLang } from '../input/input.types';
import { TTooltipSize } from '../tooltip/tooltip.types';

export enum DataTypes {
	select = 'select',
	number = 'number',
	string = 'string',
	date = 'date',
	slot = 'slot'
}

interface ColumnHeader {
	header: string;
	headerGroup?: number;
	headerGroupLabel?: string;
}

interface ColumnDisplay {
	show?: boolean;
	showForLargeScreen?: boolean;
	showForMediumScreen?: boolean;
	showForSmallScreen?: boolean;
	fixed?: boolean;
	style?: { [cssRule: string]: string };
}

interface ColumnExtensions {
	sortable?: boolean;
	sortField?: string;
	tooltip?: string;
	tooltipIcon?: string; // check tooltip component for valid strings
	tooltipSize?: TTooltipSize;
}

interface ColumnData {
	dataType: DataTypes;
	dataUnit?: string;
	dataUnitPosition?: TInputUnitPosition;
	formatNumber?: boolean;
	formatNumberLang?: TInputFormatLang;
	formatNumberDecimal?: number;
	arrow?: boolean;
	signed?: boolean;
	colored?: boolean;
	searchable?: boolean;
	selectOptions?: IGenericSelectOption[];
	dataDateFormat?: { [key: string]: any }; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
	dataDateLocale?: string; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
}

export interface Column extends ColumnHeader, ColumnDisplay, ColumnExtensions, ColumnData {
	main?: boolean;
	noneditable?: boolean;
	isMandatory?: boolean;
}

export class Locale {
	editEdit: string = 'Edit';
	editSave: string = 'Save';
	editEditAll: string = 'Edit all';
	editSaveAll: string = 'Save all';
	advancedSearchPlaceholder: string = 'Search';
	columnFilterLabel: string = 'Show/Hide columns:';
	columnFilterCheckedText: string = 'Checked';
	globalSearchPlaceholder: string = 'Search';
	paginationPreviousLabel: string = 'Prev.';
	paginationNextLabel: string = 'Next';
	paginationDisplayLabel: string = 'Display';
	downloadDataAsJSONLabel: string = 'Download data as JSON';
	downloadDataAsCSVLabel: string = 'Download data as CSV';
	copyDataLabel: string = 'Copy visible data to clipboard';
	copiedSuccessfulMessage: string = 'Data copied to clipboard!';
}

// NOTE: excessive slotting & dynamic components in Vue cannot be ported over to Angular.
// Has been converted to use slots instead with some disadvantages.
// NOTE: type has been removed on cells because of its nature to
// hold two distinct values which causes way too many headaches.
// Maybe architecture can be changed in the future, but for now,
// mirros Vue counterpart.
export interface Row {
	id: string;
	cells: any[];
	checked?: boolean;
	expandableRowRef?: string;
}
